import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import { LEGAL_DOCS } from "@/data/legal";
import "@/App.css";

function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const l = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    setLenis(l);
    let rafId;
    function raf(time) {
      l.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      l.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home lenis={lenis} />} />
          <Route path="/impressum" element={<LegalPage doc={LEGAL_DOCS.impressum} />} />
          <Route path="/datenschutz" element={<LegalPage doc={LEGAL_DOCS.datenschutz} />} />
          <Route path="/agb" element={<LegalPage doc={LEGAL_DOCS.agb} />} />
          <Route path="/stornierung" element={<LegalPage doc={LEGAL_DOCS.stornierung} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
